<template>
  <b-layout :colors="$site.colors" :header-title="$t('pages.emails.unsubscribe.unsubscribeFromList')" :header-back-route="homeRoute">
    <b-container class="mt-12">
      <div class="max-w-lg mx-auto">
        <b-error v-if="errors" :message="$t('general.errorRequest')" class="mb-6" />

        <b-card class="mb-6">
          <template v-if="success">
            <p class="text-sm text-secondary text-center">
              {{ $t('pages.emails.unsubscribe.sorryToSeeYouGo') }}
            </p>
          </template>

          <template v-else>
            <div class="text-sm text-secondary text-center mb-6" v-html="$t('pages.emails.unsubscribe.areYouSure', { email })" />

            <div class="sm:flex items-center sm:space-x-3  rtl:space-x-reverse">
              <b-button variant="action" class="w-full sm:w-1/2 mb-2" flat to="/">
                {{ $t('general.cancel') }}
              </b-button>

              <b-button variant="action" class="w-full sm:w-1/2 mb-2" :loading="unsubscribing" :disabled="unsubscribing" @click="unsubscribe">
                {{ $t('general.confirm') }}
              </b-button>
            </div>
          </template>
        </b-card>
      </div>
    </b-container>
  </b-layout>
</template>

<script setup lang="ts">
import type { LocationQueryValue } from 'vue-router';

const { $api } = useNuxtApp()
const route = useRoute()

const email: Ref<LocationQueryValue | LocationQueryValue[] | undefined> = ref(route.query.email)
const code: Ref<LocationQueryValue | LocationQueryValue[] | undefined> = ref(route.query.code)
const guid: Ref<LocationQueryValue | LocationQueryValue[] | undefined> = ref(route.query.guid)

const unsubscribing: Ref<boolean> = ref(false)
const success: Ref<boolean> = ref(false)
const errors: Ref<boolean> = ref(false)


// Note: POST-based One-Click is handled by server route `server/routes/emails/unsubscribe.post.ts`

const homeRoute = computed(() => {
  const locationStore = useLocationStore()

  return locationStore?.homeRoute || { path: '/' }
})

const unsubscribe = async () => {
  unsubscribing.value = true

  try {
    const response = await $api.marketing.massEmailUnsubscribe(email.value, code.value, guid.value)

    if (response?.success) {
      success.value = true
    } else {
      errors.value = true
    }
  } catch (error) {
    errors.value = true
  }

  unsubscribing.value = false
}
</script>
